import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const BASE = `${String(url).replace(/\/+$/, "")}/api/bonuses`;

async function request(path, options = {}) {
  const endpoint = `${BASE}${path}`;
  const response = await fetchWithAuth(endpoint, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || `Request failed ${response.status}`);
  }
  return response.json();
}

export const bonusApi = {
  list: (params = {}) => {
    const sp = new URLSearchParams();
    if (params.status) sp.set("status", params.status);
    if (params.search) sp.set("search", params.search);
    const qs = sp.toString();
    return request(qs ? `?${qs}` : "");
  },
  getById: (id) => request(`/${id}`),
  create: (payload) => request("", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) => request(`/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  updateStatus: (id, status) =>
    request(`/${id}`, { method: "PATCH", body: JSON.stringify({ status }) }),
  active: () => request("/active"),
};
